export const ALL_TOP_BOARD_CHATS_LOADED = 'CHAT_ALL_TOP_BOARD_CHATS_LOADED';
export const ALL_BOTTOM_BOARD_CHATS_LOADED = 'CHAT_ALL_BOTTOM_BOARD_CHATS_LOADED';
export const RESET_BOARD_CHATS = 'CHAT_RESET_BOARD_CHATS';

export const LOAD_BOARD_CHATS = 'CHAT_LOAD_BOARD_CHATS';
export const LOAD_CARD_CHATS = 'CHAT_LOAD_CARD_CHATS';
export const DISCONNECT_BOARD_CHATS = 'CHAT_DISCONNECT_BOARD_CHATS';
export const DISCONNECT_CARD_CHATS = 'CHAT_DISCONNECT_CARD_CHATS';

export const LOAD_BOARD_CHATS_UNREAD = 'CHAT_LOAD_BOARD_CHATS_UNREAD';
export const LOAD_CARD_CHATS_UNREAD = 'CHAT_LOAD_CARD_CHATS_UNREAD';
export const DISCONNECT_BOARD_CHATS_UNREAD = 'CHAT_DISCONNECT_BOARD_CHATS_UNREAD';
export const DISCONNECT_CARD_CHATS_UNREAD = 'CHAT_DISCONNECT_CARD_CHATS_UNREAD';

export const LOAD_MATCHED_BOARD_CHATS = 'CHAT_LOAD_MATCHED_BOARD_CHATS';
export const DISCONNECT_MATCHED_BOARD_CHATS = 'CHAT_DISCONNECT_MATCHED_BOARD_CHATS';

export const ADD_MESSAGE = 'CHAT_ADD_MESSAGE';
export const ADD_MESSAGE_SUCCESS = 'CHAT_ADD_MESSAGE_SUCCESS';
export const ADD_MESSAGE_FAILED = 'CHAT_ADD_MESSAGE_FAILED';

export const UPDATE_MESSAGE = 'CHAT_UPDATE_MESSAGE';
export const DELETE_MESSAGE = 'CHAT_DELETE_MESSAGE';

export const UPDATE_NEW_CHAT_DRAFT = 'CHAT_UPDATE_NEW_CHAT_DRAFT';
export const UPDATE_EDIT_DRAFT = 'CHAT_UPDATE_EDIT_DRAFT';
export const CLEAR_DRAFTS = 'CHAT_CLEAR_DRAFTS';
export const SET_OPEN_EDIT = 'CHAT_SET_OPEN_EDIT';


/**
 * Async method
 * @param {String} cardId - Id of card whose chat will be loaded.
 * @param {String} boardId - Currently opened board id.
 * @param { Number } limit - Load total number of chats from firebase
 * Load card chat from firebase and store into redux state
 * When search result is matched with any chat, loads all card chats.
 */
export const loadCardChats = (cardId, limit) => {
  return {
    type: LOAD_CARD_CHATS,
    cardId,
    limit
  }
}

/**
 * @param { String } boardId - Currently opened board id.
 * @param { String } limit - Load total number of chats from firebase
 * @param { String } startAtChatId - Chat Id from which list should be loaded.
 * @param { String } direction - Direction of scroll. Possible values: 'top' or 'bottom'
 * Loads board chat from firebase and store into redux state
 */
export const loadBoardChats = (boardId, limit, startAtChatId, direction) => {
  return {
    type: LOAD_BOARD_CHATS,
    boardId,
    limit,
    startAtChatId,
    direction
  }
}

/**
 * Disconnects board chats from firestore.
 * @param {String} boardId - Currently opened board id.
 */
export const disconnectBoardChats = (boardId) => {
  return {
    type: DISCONNECT_BOARD_CHATS,
    boardId
  }
}

/**
 * Disconnects card chats from firestore.
 * @param {String} cardId - Card Id.
 */
export const disconnectCardChats = (cardId) => {
  return {
    type: DISCONNECT_CARD_CHATS,
    cardId
  }
}

/**
 * Dispatch this to load card chat unread from firestore.
 * @param {String} cardId - Id of card whose chat will be loaded.
 * @param {String} boardId - Currently opened board id. optinal
 */
export const loadCardChatsUnread = (cardId, boardId) => {
  return {
    type: LOAD_CARD_CHATS_UNREAD,
    cardId,
    boardId
  }
}

/**
 * Dispatch this to loads board chat unread from firestore
 * @param { String } boardId - Currently opened board id.
 */
export const loadBoardChatsUnread = (boardId) => {
  return {
    type: LOAD_BOARD_CHATS_UNREAD,
    boardId,
  }
}

/**
 * Disconnects board chats unread from firestore.
 * @param {String} boardId - Currently opened board id.
 */
export const disconnectBoardChatsUnread = (boardId) => {
  return {
    type: DISCONNECT_BOARD_CHATS_UNREAD,
    boardId
  }
}

/**
 * Disconnects card chats unread from firestore.
 * @param {String} cardId - Card Id.
 */
export const disconnectCardChatsUnread = (cardId) => {
  return {
    type: DISCONNECT_CARD_CHATS_UNREAD,
    cardId
  }
}

/**
 * Sends request to mark given chat as deleted.
 * @param { String } id - Chat Id.
 */
export const del = (id) => {
  return {
    type: DELETE_MESSAGE,
    id
  }
}

/**
 * Saves an edited message as `messageHtml`, and nothing else.
 * @param { String } id - Chat id
 * @param { String } messageHtml - The editor's HTML
 * @param { String } cardId - Card Id. It's optional. When it's not given, considers it board chat message.
 */
export const updateMessage = (id, messageHtml, cardId) => {
  return {
    type: UPDATE_MESSAGE,
    id,
    messageHtml,
    cardId
  }
}

/**
 * Posts the editor's HTML as `messageHtml`, and nothing else.
 * @param { String } messageHtml - The editor's HTML
 * @param { String } cardId - Card Id. It's optional. When it's not provided, considers it board chat.
 */
export const add = (messageHtml, cardId, boardId) => {
  return {
    type: ADD_MESSAGE,
    messageHtml,
    cardId,
    boardId
  }
}

export const _addSuccess = (messageHtml, cardId, boardId) => {
  return {
    type: ADD_MESSAGE_SUCCESS,
    messageHtml,
    cardId,
    boardId
  }
}

export const _addFailed = (messageHtml, cardId, boardId, error) => {
  return {
    type: ADD_MESSAGE_FAILED,
    messageHtml,
    cardId,
    boardId,
    error
  }
}

/**
 * @param {String} requesterId
 * @param {String} boardId
 * @param {Array} chatIds
 * Loads board chats for given chat ids.
 */
export const loadMatchedBoardChats = (requesterId, boardId, chatIds) => {
  return {
    type: LOAD_MATCHED_BOARD_CHATS,
    requesterId,
    boardId,
    chatIds
  }
}

/**
 * Disconnect firebase live listning for mathced board chats.
 */
export const disconnectMathcedBoardChats = (requesterId) => {
  return {
    type: DISCONNECT_MATCHED_BOARD_CHATS,
    requesterId
  }
}

/**
 * Records what the user has typed into the chat box and not yet sent, so a refresh, a second tab
 * and the AI Helper all see the same text.
 * @param { String } containerId - Card id for a card chat, board id for a board chat.
 * @param { String } message - The unsent text. An empty value drops the draft.
 */
export const updateNewChatDraft = (containerId, message) => {
  return {
    type: UPDATE_NEW_CHAT_DRAFT,
    containerId,
    message
  }
}

/**
 * Records an edit the user has started on a posted message and not sent, so a refresh, a second tab,
 * the in-place editor and the full screen dialog all see the same text.
 * @param { String } chatMessageId - Id of the message being edited.
 * @param { String } message - The unsent edit. An empty value drops the draft.
 */
export const updateEditDraft = (chatMessageId, message) => {
  return {
    type: UPDATE_EDIT_DRAFT,
    chatMessageId,
    message
  }
}

/**
 * Records which posted message is open for editing in this tab; not persisted, so a draft left from
 * an earlier visit is not taken for the edit the user is looking at.
 * @param { String } chatMessageId - Id of the message open for editing, null when none is.
 */
export const setOpenEdit = (chatMessageId) => {
  return {
    type: SET_OPEN_EDIT,
    chatMessageId
  }
}

/**
 * Drops every unsent chat message and edit, on logout, so the next user of this browser never sees them.
 */
export const clearDrafts = () => {
  return {
    type: CLEAR_DRAFTS
  }
}
